import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';  // <-- fixed import
import Home from './Home/Home';        // Home component
import About from './About/About';    // About component
import Services from './Service/Services';    // About component
import Project from './Project/Project';    // About component
import ResponsiveNavbar from './ResponsiveNavbar';
import Footer from './Footer';
import LogoSplash from './LogoSplash';
import "./i18n"; // i18n config (includes language setup)
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <LogoSplash />;

  return (
    <div className="App">
      <Router>
        <ResponsiveNavbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<Services />} />
           <Route path="/project" element={<Project />} />
          {/* Add other routes here if needed */}
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
